import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { lookupService } from "../services/lookupService";
import { LookupState } from "../models/state/lookupState";
import { LookupResource } from "../models/resource/lookupResource";
import { LookupValueModel } from "../models/models/lookupValueModel";
import { LookupValueResource } from "../models/resource/lookupValueResource";

const initialState: LookupState = {
  lookup: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  lookupValue: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  lookupsList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  lookupsParentList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  mainPurposeOfFundUtilizationList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  incorporationJurisdictionList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  ownershipstructureList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  termsOfAgreementChangesList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  investorsNumberRestrictionList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  islamicShariaComplianceList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  offerIssuerRaiseFundsList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  offerIssuerRaiseFundsAnotherPlatformList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  percentageFundsRaiseBeforeList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  fundsPreviouslyOfferIssuerList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  companyShariaaCompilantList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  offerIssuerPayList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  existingDividendOrDistributionPolicyList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  sectorsList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  categoriesList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  statusList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  legalStructureofTheOfferIssuerList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  previouslyIssuingOtherOfferingsList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  concurrentlyIssuingOtherOfferingList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  preventingPayingDividendList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  preventingDividendPolicyList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  legalProceedingsList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  offerIssuerHaveRelationShipList: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  preferenceCommunication: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  aicClient: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  gender: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  designations: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  monthlyIncomme: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  averageAnnualIncome: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  estimatedWealth: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  investmentObjective: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  riskTolerance: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  preferredProducts: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  politicallyExposedPersonPositions: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
  beneficiaryRelationship: {
    token: null,
    status: "idle",
    isLoading: false,
    error: null,
    message: "",
    blobData: null,
    data: null,
  },
};

export const getLookupsList = createAsyncThunk<
  LookupValueModel,
  void,
  { rejectValue: string }
>("lookup/getLookupsList", async (_, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsList();
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getAllLookups = createAsyncThunk<
  LookupValueModel,
  void,
  { rejectValue: string }
>("lookup/getAllLookups", async (_, { rejectWithValue }) => {
  try {
    const response = await lookupService.getAllLookups();
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const deleteLookupValue = createAsyncThunk<
  LookupValueModel,
  { data: number },
  { rejectValue: string }
>("lookup/deleteLookupValue", async ({ data }, { rejectWithValue }) => {
  try {
    const response = await lookupService.deleteLookupValue(data);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const saveLookupValue = createAsyncThunk<
  LookupValueResource,
  { data: LookupValueResource },
  { rejectValue: string }
>("lookup/saveLookupValue", async ({ data }, { rejectWithValue }) => {
  try {
    const response = await lookupService.saveLookupValue(data);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const saveLookup = createAsyncThunk<
  LookupResource,
  { data: LookupResource },
  { rejectValue: string }
>("lookup/saveLookup", async ({ data }, { rejectWithValue }) => {
  try {
    const response = await lookupService.saveLookup(data);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getLookupById = createAsyncThunk<
  LookupResource,
  { id: number },
  { rejectValue: string }
>("lookup/getLookupById", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupById(id);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getLookupValueById = createAsyncThunk<
  LookupValueResource,
  { id: number },
  { rejectValue: string }
>("lookup/getLookupValueById", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupValueById(id);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getLegalStructureofTheOfferIssuer = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getLegalStructureofTheOfferIssuer",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getPreferenceCommunication = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getPreferenceCommunication",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getAICClient = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getAICClient", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getGender = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getGender", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getDesignations = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getDesignations", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getMonthlyIncomme = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getMonthlyIncomme", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getAverageAnnualIncome = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getAverageAnnualIncome",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getEstimatedWealth = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getEstimatedWealth", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getIncorporationJurisdictionList = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getIncorporationJurisdictionList",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getMainPurposeOfFundUtilization = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getMainPurposeOfFundUtilization",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getOwnershipstructureList = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getOwnershipstructureList",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getTermsOfAgreementChangesList = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getTermsOfAgreementChangesList",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getOfferIssuerPayList = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getOfferIssuerPayList", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getExistingDividendOrDistributionPolicyList = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getExistingDividendOrDistributionPolicyList",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getPreventingDividendPolicyList = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getPreventingDividendPolicyList",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getLegalProceedingsList = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getLegalProceedingsList",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getPreventingPayingDividendList = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getPreventingPayingDividendList",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getIslamicShariaComplianceList = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getIslamicShariaComplianceList",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);
export const getInvestorsNumberRestrictionList = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getInvestorsNumberRestrictionList",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getOfferIssuerRaiseFunds = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getOfferIssuerRaiseFunds",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getofferIssuerRaiseFundsOnAnotherPlatform = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getofferIssuerRaiseFundsOnAnotherPlatform",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getPercentageFundsRaiseBefore = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getPercentageFundsRaiseBefore",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getPreviouslyIssuingOtherOfferings = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getPreviouslyIssuingOtherOfferings",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getConcurrentlyIssuingOtherOffering = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getConcurrentlyIssuingOtherOffering",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getOfferIssuerHaveRelationShip = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getOfferIssuerHaveRelationShip",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getFundsPreviouslyOfferIssuer = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getFundsPreviouslyOfferIssuer",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getCompanyShariaaCompilant = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getCompanyShariaaCompilant",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getSectors = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getSectors", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getCategories = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getCategories", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getStatus = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getStatus", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getInvestmentObjective = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getInvestmentObjective",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getRiskTolerance = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getRiskTolerance", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getPreferredProducts = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>("lookup/getPreferredProducts", async ({ lookupId }, { rejectWithValue }) => {
  try {
    const response = await lookupService.getLookupsValueList(lookupId);
    return response;
  } catch (error: any) {
    return rejectWithValue("An unexpected error occurred");
  }
});

export const getPoliticallyExposedPersonPositions = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getPoliticallyExposedPersonPositions",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

export const getBeneficiaryRelationship = createAsyncThunk<
  any,
  { lookupId: number },
  { rejectValue: string }
>(
  "lookup/getBeneficiaryRelationship",
  async ({ lookupId }, { rejectWithValue }) => {
    try {
      const response = await lookupService.getLookupsValueList(lookupId);
      return response;
    } catch (error: any) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

const lookupReducer = createSlice({
  name: "lookup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLookupsList.pending, (state) => {
        state.lookupsList.status = "loading";
        state.lookupsList.isLoading = true;
      })
      .addCase(getLookupsList.fulfilled, (state, action) => {
        state.lookupsList.status = "idle";
        state.lookupsList.data = action.payload;
        state.lookupsList.isLoading = false;
      })
      .addCase(getLookupsList.rejected, (state, action) => {
        state.lookupsList.status = "failed";
        state.lookupsList.isLoading = false;
        if (action.payload) {
          state.lookupsList.error = action.payload;
          state.lookupsList.message = action.payload;
        } else {
          state.lookupsList.message = "An unexpected error occurred";
        }
      })
      .addCase(getAllLookups.pending, (state) => {
        state.lookupsParentList.status = "loading";
        state.lookupsParentList.isLoading = true;
      })
      .addCase(getAllLookups.fulfilled, (state, action) => {
        state.lookupsParentList.status = "idle";
        state.lookupsParentList.data = action.payload;
        state.lookupsParentList.isLoading = false;
      })
      .addCase(getAllLookups.rejected, (state, action) => {
        state.lookupsParentList.status = "failed";
        state.lookupsParentList.isLoading = false;
        if (action.payload) {
          state.lookupsParentList.error = action.payload;
          state.lookupsParentList.message = action.payload;
        } else {
          state.lookupsParentList.message = "An unexpected error occurred";
        }
      })
      .addCase(saveLookup.pending, (state) => {
        state.lookup.status = "loading";
        state.lookup.isLoading = true;
      })
      .addCase(saveLookup.fulfilled, (state, action) => {
        state.lookup.status = "idle";
        state.lookup.data = action.payload;
        state.lookup.isLoading = false;
      })
      .addCase(saveLookup.rejected, (state, action) => {
        state.lookup.status = "failed";
        state.lookup.isLoading = false;
        if (action.payload) {
          state.lookup.error = action.payload;
          state.lookup.message = action.payload;
        } else {
          state.lookup.message = "An unexpected error occurred";
        }
      })
      .addCase(getLookupById.pending, (state) => {
        state.lookup.status = "loading";
        state.lookup.isLoading = true;
      })
      .addCase(getLookupById.fulfilled, (state, action) => {
        state.lookup.status = "idle";
        state.lookup.data = action.payload;
        state.lookup.isLoading = false;
      })
      .addCase(getLookupById.rejected, (state, action) => {
        state.lookup.status = "failed";
        state.lookup.isLoading = false;
        if (action.payload) {
          state.lookup.error = action.payload;
          state.lookup.message = action.payload;
        } else {
          state.lookup.message = "An unexpected error occurred";
        }
      })
      .addCase(getLookupValueById.pending, (state) => {
        state.lookupValue.status = "loading";
        state.lookupValue.isLoading = true;
      })
      .addCase(getLookupValueById.fulfilled, (state, action) => {
        state.lookupValue.status = "idle";
        state.lookupValue.data = action.payload;
        state.lookupValue.isLoading = false;
      })
      .addCase(getLookupValueById.rejected, (state, action) => {
        state.lookupValue.status = "failed";
        state.lookupValue.isLoading = false;
        if (action.payload) {
          state.lookupValue.error = action.payload;
          state.lookupValue.message = action.payload;
        } else {
          state.lookupValue.message = "An unexpected error occurred";
        }
      })
      .addCase(getMainPurposeOfFundUtilization.pending, (state) => {
        state.mainPurposeOfFundUtilizationList.status = "loading";
        state.mainPurposeOfFundUtilizationList.isLoading = true;
      })
      .addCase(getMainPurposeOfFundUtilization.fulfilled, (state, action) => {
        state.mainPurposeOfFundUtilizationList.status = "idle";
        state.mainPurposeOfFundUtilizationList.data = action.payload;
        state.mainPurposeOfFundUtilizationList.isLoading = false;
      })
      .addCase(getMainPurposeOfFundUtilization.rejected, (state, action) => {
        state.mainPurposeOfFundUtilizationList.status = "failed";
        state.mainPurposeOfFundUtilizationList.isLoading = false;
        if (action.payload) {
          state.mainPurposeOfFundUtilizationList.error = action.payload;
          state.mainPurposeOfFundUtilizationList.message = action.payload;
        } else {
          state.mainPurposeOfFundUtilizationList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getLegalStructureofTheOfferIssuer.pending, (state) => {
        state.legalStructureofTheOfferIssuerList.status = "loading";
        state.legalStructureofTheOfferIssuerList.isLoading = true;
      })
      .addCase(getLegalStructureofTheOfferIssuer.fulfilled, (state, action) => {
        state.legalStructureofTheOfferIssuerList.status = "idle";
        state.legalStructureofTheOfferIssuerList.data = action.payload;
        state.legalStructureofTheOfferIssuerList.isLoading = false;
      })
      .addCase(getLegalStructureofTheOfferIssuer.rejected, (state, action) => {
        state.legalStructureofTheOfferIssuerList.status = "failed";
        state.legalStructureofTheOfferIssuerList.isLoading = false;
        if (action.payload) {
          state.legalStructureofTheOfferIssuerList.error = action.payload;
          state.legalStructureofTheOfferIssuerList.message = action.payload;
        } else {
          state.legalStructureofTheOfferIssuerList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getPreferenceCommunication.pending, (state) => {
        state.preferenceCommunication.status = "loading";
        state.preferenceCommunication.isLoading = true;
      })
      .addCase(getPreferenceCommunication.fulfilled, (state, action) => {
        state.preferenceCommunication.status = "idle";
        state.preferenceCommunication.data = action.payload;
        state.preferenceCommunication.isLoading = false;
      })
      .addCase(getPreferenceCommunication.rejected, (state, action) => {
        state.preferenceCommunication.status = "failed";
        state.preferenceCommunication.isLoading = false;
        if (action.payload) {
          state.preferenceCommunication.error = action.payload;
          state.preferenceCommunication.message = action.payload;
        } else {
          state.preferenceCommunication.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getAICClient.pending, (state) => {
        state.aicClient.status = "loading";
        state.aicClient.isLoading = true;
      })
      .addCase(getAICClient.fulfilled, (state, action) => {
        state.aicClient.status = "idle";
        state.aicClient.data = action.payload;
        state.aicClient.isLoading = false;
      })
      .addCase(getAICClient.rejected, (state, action) => {
        state.aicClient.status = "failed";
        state.aicClient.isLoading = false;
        if (action.payload) {
          state.aicClient.error = action.payload;
          state.aicClient.message = action.payload;
        } else {
          state.aicClient.message = "An unexpected error occurred";
        }
      })
      .addCase(getGender.pending, (state) => {
        state.gender.status = "loading";
        state.gender.isLoading = true;
      })
      .addCase(getGender.fulfilled, (state, action) => {
        state.gender.status = "idle";
        state.gender.data = action.payload;
        state.gender.isLoading = false;
      })
      .addCase(getGender.rejected, (state, action) => {
        state.gender.status = "failed";
        state.gender.isLoading = false;
        if (action.payload) {
          state.gender.error = action.payload;
          state.gender.message = action.payload;
        } else {
          state.gender.message = "An unexpected error occurred";
        }
      })
      .addCase(getDesignations.pending, (state) => {
        state.designations.status = "loading";
        state.designations.isLoading = true;
      })
      .addCase(getDesignations.fulfilled, (state, action) => {
        state.designations.status = "idle";
        state.designations.data = action.payload;
        state.designations.isLoading = false;
      })
      .addCase(getDesignations.rejected, (state, action) => {
        state.designations.status = "failed";
        state.designations.isLoading = false;
        if (action.payload) {
          state.designations.error = action.payload;
          state.designations.message = action.payload;
        } else {
          state.designations.message = "An unexpected error occurred";
        }
      })
      .addCase(getMonthlyIncomme.pending, (state) => {
        state.monthlyIncomme.status = "loading";
        state.monthlyIncomme.isLoading = true;
      })
      .addCase(getMonthlyIncomme.fulfilled, (state, action) => {
        state.monthlyIncomme.status = "idle";
        state.monthlyIncomme.data = action.payload;
        state.monthlyIncomme.isLoading = false;
      })
      .addCase(getMonthlyIncomme.rejected, (state, action) => {
        state.monthlyIncomme.status = "failed";
        state.monthlyIncomme.isLoading = false;
        if (action.payload) {
          state.monthlyIncomme.error = action.payload;
          state.monthlyIncomme.message = action.payload;
        } else {
          state.monthlyIncomme.message = "An unexpected error occurred";
        }
      })
      .addCase(getAverageAnnualIncome.pending, (state) => {
        state.averageAnnualIncome.status = "loading";
        state.averageAnnualIncome.isLoading = true;
      })
      .addCase(getAverageAnnualIncome.fulfilled, (state, action) => {
        state.averageAnnualIncome.status = "idle";
        state.averageAnnualIncome.data = action.payload;
        state.averageAnnualIncome.isLoading = false;
      })
      .addCase(getAverageAnnualIncome.rejected, (state, action) => {
        state.averageAnnualIncome.status = "failed";
        state.averageAnnualIncome.isLoading = false;
        if (action.payload) {
          state.averageAnnualIncome.error = action.payload;
          state.averageAnnualIncome.message = action.payload;
        } else {
          state.averageAnnualIncome.message = "An unexpected error occurred";
        }
      })
      .addCase(getEstimatedWealth.pending, (state) => {
        state.estimatedWealth.status = "loading";
        state.estimatedWealth.isLoading = true;
      })
      .addCase(getEstimatedWealth.fulfilled, (state, action) => {
        state.estimatedWealth.status = "idle";
        state.estimatedWealth.data = action.payload;
        state.estimatedWealth.isLoading = false;
      })
      .addCase(getEstimatedWealth.rejected, (state, action) => {
        state.estimatedWealth.status = "failed";
        state.estimatedWealth.isLoading = false;
        if (action.payload) {
          state.estimatedWealth.error = action.payload;
          state.estimatedWealth.message = action.payload;
        } else {
          state.estimatedWealth.message = "An unexpected error occurred";
        }
      })
      .addCase(getPreviouslyIssuingOtherOfferings.pending, (state) => {
        state.previouslyIssuingOtherOfferingsList.status = "loading";
        state.previouslyIssuingOtherOfferingsList.isLoading = true;
      })
      .addCase(
        getPreviouslyIssuingOtherOfferings.fulfilled,
        (state, action) => {
          state.previouslyIssuingOtherOfferingsList.status = "idle";
          state.previouslyIssuingOtherOfferingsList.data = action.payload;
          state.previouslyIssuingOtherOfferingsList.isLoading = false;
        }
      )
      .addCase(getPreviouslyIssuingOtherOfferings.rejected, (state, action) => {
        state.previouslyIssuingOtherOfferingsList.status = "failed";
        state.previouslyIssuingOtherOfferingsList.isLoading = false;
        if (action.payload) {
          state.previouslyIssuingOtherOfferingsList.error = action.payload;
          state.previouslyIssuingOtherOfferingsList.message = action.payload;
        } else {
          state.previouslyIssuingOtherOfferingsList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getIncorporationJurisdictionList.pending, (state) => {
        state.incorporationJurisdictionList.status = "loading";
        state.incorporationJurisdictionList.isLoading = true;
      })
      .addCase(getIncorporationJurisdictionList.fulfilled, (state, action) => {
        state.incorporationJurisdictionList.status = "idle";
        state.incorporationJurisdictionList.data = action.payload;
        state.incorporationJurisdictionList.isLoading = false;
      })
      .addCase(getIncorporationJurisdictionList.rejected, (state, action) => {
        state.incorporationJurisdictionList.status = "failed";
        state.incorporationJurisdictionList.isLoading = false;
        if (action.payload) {
          state.incorporationJurisdictionList.error = action.payload;
          state.incorporationJurisdictionList.message = action.payload;
        } else {
          state.incorporationJurisdictionList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getOwnershipstructureList.pending, (state) => {
        state.ownershipstructureList.status = "loading";
        state.ownershipstructureList.isLoading = true;
      })
      .addCase(getOwnershipstructureList.fulfilled, (state, action) => {
        state.ownershipstructureList.status = "idle";
        state.ownershipstructureList.data = action.payload;
        state.ownershipstructureList.isLoading = false;
      })
      .addCase(getOwnershipstructureList.rejected, (state, action) => {
        state.ownershipstructureList.status = "failed";
        state.ownershipstructureList.isLoading = false;
        if (action.payload) {
          state.ownershipstructureList.error = action.payload;
          state.ownershipstructureList.message = action.payload;
        } else {
          state.ownershipstructureList.message = "An unexpected error occurred";
        }
      })
      .addCase(getConcurrentlyIssuingOtherOffering.pending, (state) => {
        state.concurrentlyIssuingOtherOfferingList.status = "loading";
        state.concurrentlyIssuingOtherOfferingList.isLoading = true;
      })
      .addCase(
        getConcurrentlyIssuingOtherOffering.fulfilled,
        (state, action) => {
          state.concurrentlyIssuingOtherOfferingList.status = "idle";
          state.concurrentlyIssuingOtherOfferingList.data = action.payload;
          state.concurrentlyIssuingOtherOfferingList.isLoading = false;
        }
      )
      .addCase(
        getConcurrentlyIssuingOtherOffering.rejected,
        (state, action) => {
          state.concurrentlyIssuingOtherOfferingList.status = "failed";
          state.concurrentlyIssuingOtherOfferingList.isLoading = false;
          if (action.payload) {
            state.concurrentlyIssuingOtherOfferingList.error = action.payload;
            state.concurrentlyIssuingOtherOfferingList.message = action.payload;
          } else {
            state.concurrentlyIssuingOtherOfferingList.message =
              "An unexpected error occurred";
          }
        }
      )
      .addCase(getOfferIssuerHaveRelationShip.pending, (state) => {
        state.offerIssuerHaveRelationShipList.status = "loading";
        state.offerIssuerHaveRelationShipList.isLoading = true;
      })
      .addCase(getOfferIssuerHaveRelationShip.fulfilled, (state, action) => {
        state.offerIssuerHaveRelationShipList.status = "idle";
        state.offerIssuerHaveRelationShipList.data = action.payload;
        state.offerIssuerHaveRelationShipList.isLoading = false;
      })
      .addCase(getOfferIssuerHaveRelationShip.rejected, (state, action) => {
        state.offerIssuerHaveRelationShipList.status = "failed";
        state.offerIssuerHaveRelationShipList.isLoading = false;
        if (action.payload) {
          state.offerIssuerHaveRelationShipList.error = action.payload;
          state.offerIssuerHaveRelationShipList.message = action.payload;
        } else {
          state.offerIssuerHaveRelationShipList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getTermsOfAgreementChangesList.pending, (state) => {
        state.termsOfAgreementChangesList.status = "loading";
        state.termsOfAgreementChangesList.isLoading = true;
      })
      .addCase(getTermsOfAgreementChangesList.fulfilled, (state, action) => {
        state.termsOfAgreementChangesList.status = "idle";
        state.termsOfAgreementChangesList.data = action.payload;
        state.termsOfAgreementChangesList.isLoading = false;
      })
      .addCase(getTermsOfAgreementChangesList.rejected, (state, action) => {
        state.termsOfAgreementChangesList.status = "failed";
        state.termsOfAgreementChangesList.isLoading = false;
        if (action.payload) {
          state.termsOfAgreementChangesList.error = action.payload;
          state.termsOfAgreementChangesList.message = action.payload;
        } else {
          state.termsOfAgreementChangesList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getIslamicShariaComplianceList.pending, (state) => {
        state.islamicShariaComplianceList.status = "loading";
        state.islamicShariaComplianceList.isLoading = true;
      })
      .addCase(getIslamicShariaComplianceList.fulfilled, (state, action) => {
        state.islamicShariaComplianceList.status = "idle";
        state.islamicShariaComplianceList.data = action.payload;
        state.islamicShariaComplianceList.isLoading = false;
      })
      .addCase(getIslamicShariaComplianceList.rejected, (state, action) => {
        state.islamicShariaComplianceList.status = "failed";
        state.islamicShariaComplianceList.isLoading = false;
        if (action.payload) {
          state.islamicShariaComplianceList.error = action.payload;
          state.islamicShariaComplianceList.message = action.payload;
        } else {
          state.islamicShariaComplianceList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getInvestorsNumberRestrictionList.pending, (state) => {
        state.investorsNumberRestrictionList.status = "loading";
        state.investorsNumberRestrictionList.isLoading = true;
      })
      .addCase(getInvestorsNumberRestrictionList.fulfilled, (state, action) => {
        state.investorsNumberRestrictionList.status = "idle";
        state.investorsNumberRestrictionList.data = action.payload;
        state.investorsNumberRestrictionList.isLoading = false;
      })
      .addCase(getInvestorsNumberRestrictionList.rejected, (state, action) => {
        state.investorsNumberRestrictionList.status = "failed";
        state.investorsNumberRestrictionList.isLoading = false;
        if (action.payload) {
          state.investorsNumberRestrictionList.error = action.payload;
          state.investorsNumberRestrictionList.message = action.payload;
        } else {
          state.investorsNumberRestrictionList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getOfferIssuerRaiseFunds.pending, (state) => {
        state.offerIssuerRaiseFundsList.status = "loading";
        state.offerIssuerRaiseFundsList.isLoading = true;
      })
      .addCase(getOfferIssuerRaiseFunds.fulfilled, (state, action) => {
        state.offerIssuerRaiseFundsList.status = "idle";
        state.offerIssuerRaiseFundsList.data = action.payload;
        state.offerIssuerRaiseFundsList.isLoading = false;
      })
      .addCase(getOfferIssuerRaiseFunds.rejected, (state, action) => {
        state.offerIssuerRaiseFundsList.status = "failed";
        state.offerIssuerRaiseFundsList.isLoading = false;
        if (action.payload) {
          state.offerIssuerRaiseFundsList.error = action.payload;
          state.offerIssuerRaiseFundsList.message = action.payload;
        } else {
          state.offerIssuerRaiseFundsList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getofferIssuerRaiseFundsOnAnotherPlatform.pending, (state) => {
        state.offerIssuerRaiseFundsAnotherPlatformList.status = "loading";
        state.offerIssuerRaiseFundsAnotherPlatformList.isLoading = true;
      })
      .addCase(
        getofferIssuerRaiseFundsOnAnotherPlatform.fulfilled,
        (state, action) => {
          state.offerIssuerRaiseFundsAnotherPlatformList.status = "idle";
          state.offerIssuerRaiseFundsAnotherPlatformList.data = action.payload;
          state.offerIssuerRaiseFundsAnotherPlatformList.isLoading = false;
        }
      )
      .addCase(
        getofferIssuerRaiseFundsOnAnotherPlatform.rejected,
        (state, action) => {
          state.offerIssuerRaiseFundsAnotherPlatformList.status = "failed";
          state.offerIssuerRaiseFundsAnotherPlatformList.isLoading = false;
          if (action.payload) {
            state.offerIssuerRaiseFundsAnotherPlatformList.error =
              action.payload;
            state.offerIssuerRaiseFundsAnotherPlatformList.message =
              action.payload;
          } else {
            state.offerIssuerRaiseFundsAnotherPlatformList.message =
              "An unexpected error occurred";
          }
        }
      )
      .addCase(getPercentageFundsRaiseBefore.pending, (state) => {
        state.percentageFundsRaiseBeforeList.status = "loading";
        state.percentageFundsRaiseBeforeList.isLoading = true;
      })
      .addCase(getPercentageFundsRaiseBefore.fulfilled, (state, action) => {
        state.percentageFundsRaiseBeforeList.status = "idle";
        state.percentageFundsRaiseBeforeList.data = action.payload;
        state.percentageFundsRaiseBeforeList.isLoading = false;
      })
      .addCase(getPercentageFundsRaiseBefore.rejected, (state, action) => {
        state.percentageFundsRaiseBeforeList.status = "failed";
        state.percentageFundsRaiseBeforeList.isLoading = false;
        if (action.payload) {
          state.percentageFundsRaiseBeforeList.error = action.payload;
          state.percentageFundsRaiseBeforeList.message = action.payload;
        } else {
          state.percentageFundsRaiseBeforeList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getFundsPreviouslyOfferIssuer.pending, (state) => {
        state.fundsPreviouslyOfferIssuerList.status = "loading";
        state.fundsPreviouslyOfferIssuerList.isLoading = true;
      })
      .addCase(getFundsPreviouslyOfferIssuer.fulfilled, (state, action) => {
        state.fundsPreviouslyOfferIssuerList.status = "idle";
        state.fundsPreviouslyOfferIssuerList.data = action.payload;
        state.fundsPreviouslyOfferIssuerList.isLoading = false;
      })
      .addCase(getFundsPreviouslyOfferIssuer.rejected, (state, action) => {
        state.fundsPreviouslyOfferIssuerList.status = "failed";
        state.fundsPreviouslyOfferIssuerList.isLoading = false;
        if (action.payload) {
          state.fundsPreviouslyOfferIssuerList.error = action.payload;
          state.fundsPreviouslyOfferIssuerList.message = action.payload;
        } else {
          state.fundsPreviouslyOfferIssuerList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getCompanyShariaaCompilant.pending, (state) => {
        state.companyShariaaCompilantList.status = "loading";
        state.companyShariaaCompilantList.isLoading = true;
      })
      .addCase(getCompanyShariaaCompilant.fulfilled, (state, action) => {
        state.companyShariaaCompilantList.status = "idle";
        state.companyShariaaCompilantList.data = action.payload;
        state.companyShariaaCompilantList.isLoading = false;
      })
      .addCase(getCompanyShariaaCompilant.rejected, (state, action) => {
        state.companyShariaaCompilantList.status = "failed";
        state.companyShariaaCompilantList.isLoading = false;
        if (action.payload) {
          state.companyShariaaCompilantList.error = action.payload;
          state.companyShariaaCompilantList.message = action.payload;
        } else {
          state.companyShariaaCompilantList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getOfferIssuerPayList.pending, (state) => {
        state.offerIssuerPayList.status = "loading";
        state.offerIssuerPayList.isLoading = true;
      })
      .addCase(getOfferIssuerPayList.fulfilled, (state, action) => {
        state.offerIssuerPayList.status = "idle";
        state.offerIssuerPayList.data = action.payload;
        state.offerIssuerPayList.isLoading = false;
      })
      .addCase(getOfferIssuerPayList.rejected, (state, action) => {
        state.offerIssuerPayList.status = "failed";
        state.offerIssuerPayList.isLoading = false;
        if (action.payload) {
          state.offerIssuerPayList.error = action.payload;
          state.offerIssuerPayList.message = action.payload;
        } else {
          state.offerIssuerPayList.message = "An unexpected error occurred";
        }
      })
      .addCase(getExistingDividendOrDistributionPolicyList.pending, (state) => {
        state.existingDividendOrDistributionPolicyList.status = "loading";
        state.existingDividendOrDistributionPolicyList.isLoading = true;
      })
      .addCase(
        getExistingDividendOrDistributionPolicyList.fulfilled,
        (state, action) => {
          state.existingDividendOrDistributionPolicyList.status = "idle";
          state.existingDividendOrDistributionPolicyList.data = action.payload;
          state.existingDividendOrDistributionPolicyList.isLoading = false;
        }
      )
      .addCase(
        getExistingDividendOrDistributionPolicyList.rejected,
        (state, action) => {
          state.existingDividendOrDistributionPolicyList.status = "failed";
          state.existingDividendOrDistributionPolicyList.isLoading = false;
          if (action.payload) {
            state.existingDividendOrDistributionPolicyList.error =
              action.payload;
            state.existingDividendOrDistributionPolicyList.message =
              action.payload;
          } else {
            state.existingDividendOrDistributionPolicyList.message =
              "An unexpected error occurred";
          }
        }
      )
      .addCase(getPreventingDividendPolicyList.pending, (state) => {
        state.preventingDividendPolicyList.status = "loading";
        state.preventingDividendPolicyList.isLoading = true;
      })
      .addCase(getPreventingDividendPolicyList.fulfilled, (state, action) => {
        state.preventingDividendPolicyList.status = "idle";
        state.preventingDividendPolicyList.data = action.payload;
        state.preventingDividendPolicyList.isLoading = false;
      })
      .addCase(getPreventingDividendPolicyList.rejected, (state, action) => {
        state.preventingDividendPolicyList.status = "failed";
        state.preventingDividendPolicyList.isLoading = false;
        if (action.payload) {
          state.preventingDividendPolicyList.error = action.payload;
          state.preventingDividendPolicyList.message = action.payload;
        } else {
          state.preventingDividendPolicyList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getLegalProceedingsList.pending, (state) => {
        state.legalProceedingsList.status = "loading";
        state.legalProceedingsList.isLoading = true;
      })
      .addCase(getLegalProceedingsList.fulfilled, (state, action) => {
        state.legalProceedingsList.status = "idle";
        state.legalProceedingsList.data = action.payload;
        state.legalProceedingsList.isLoading = false;
      })
      .addCase(getLegalProceedingsList.rejected, (state, action) => {
        state.legalProceedingsList.status = "failed";
        state.legalProceedingsList.isLoading = false;
        if (action.payload) {
          state.legalProceedingsList.error = action.payload;
          state.legalProceedingsList.message = action.payload;
        } else {
          state.legalProceedingsList.message = "An unexpected error occurred";
        }
      })
      .addCase(getPreventingPayingDividendList.pending, (state) => {
        state.preventingPayingDividendList.status = "loading";
        state.preventingPayingDividendList.isLoading = true;
      })
      .addCase(getPreventingPayingDividendList.fulfilled, (state, action) => {
        state.preventingPayingDividendList.status = "idle";
        state.preventingPayingDividendList.data = action.payload;
        state.preventingPayingDividendList.isLoading = false;
      })
      .addCase(getPreventingPayingDividendList.rejected, (state, action) => {
        state.preventingPayingDividendList.status = "failed";
        state.preventingPayingDividendList.isLoading = false;
        if (action.payload) {
          state.preventingPayingDividendList.error = action.payload;
          state.preventingPayingDividendList.message = action.payload;
        } else {
          state.preventingPayingDividendList.message =
            "An unexpected error occurred";
        }
      })
      .addCase(getSectors.pending, (state) => {
        state.sectorsList.status = "loading";
        state.sectorsList.isLoading = true;
      })
      .addCase(getSectors.fulfilled, (state, action) => {
        state.sectorsList.status = "idle";
        state.sectorsList.data = action.payload;
        state.sectorsList.isLoading = false;
      })
      .addCase(getSectors.rejected, (state, action) => {
        state.sectorsList.status = "failed";
        state.sectorsList.isLoading = false;
        if (action.payload) {
          state.sectorsList.error = action.payload;
          state.sectorsList.message = action.payload;
        } else {
          state.sectorsList.message = "An unexpected error occurred";
        }
      })
      .addCase(getCategories.pending, (state) => {
        state.categoriesList.status = "loading";
        state.categoriesList.isLoading = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.categoriesList.status = "idle";
        state.categoriesList.data = action.payload;
        state.categoriesList.isLoading = false;
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.categoriesList.status = "failed";
        state.categoriesList.isLoading = false;
        if (action.payload) {
          state.categoriesList.error = action.payload;
          state.categoriesList.message = action.payload;
        } else {
          state.categoriesList.message = "An unexpected error occurred";
        }
      })
      .addCase(getStatus.pending, (state) => {
        state.statusList.status = "loading";
        state.statusList.isLoading = true;
      })
      .addCase(getStatus.fulfilled, (state, action) => {
        state.statusList.status = "idle";
        state.statusList.data = action.payload;
        state.statusList.isLoading = false;
      })
      .addCase(getStatus.rejected, (state, action) => {
        state.statusList.status = "failed";
        state.statusList.isLoading = false;
        if (action.payload) {
          state.statusList.error = action.payload;
          state.statusList.message = action.payload;
        } else {
          state.statusList.message = "An unexpected error occurred";
        }
      })
      .addCase(getInvestmentObjective.pending, (state) => {
        state.investmentObjective.status = "loading";
        state.investmentObjective.isLoading = true;
      })
      .addCase(getInvestmentObjective.fulfilled, (state, action) => {
        state.investmentObjective.status = "idle";
        state.investmentObjective.data = action.payload;
        state.investmentObjective.isLoading = false;
      })
      .addCase(getInvestmentObjective.rejected, (state, action) => {
        state.investmentObjective.status = "failed";
        state.investmentObjective.isLoading = false;
        if (action.payload) {
          state.investmentObjective.error = action.payload;
          state.investmentObjective.message = action.payload;
        } else {
          state.investmentObjective.message = "An unexpected error occurred";
        }
      })
      .addCase(getRiskTolerance.pending, (state) => {
        state.riskTolerance.status = "loading";
        state.riskTolerance.isLoading = true;
      })
      .addCase(getRiskTolerance.fulfilled, (state, action) => {
        state.riskTolerance.status = "idle";
        state.riskTolerance.data = action.payload;
        state.riskTolerance.isLoading = false;
      })
      .addCase(getRiskTolerance.rejected, (state, action) => {
        state.riskTolerance.status = "failed";
        state.riskTolerance.isLoading = false;
        if (action.payload) {
          state.riskTolerance.error = action.payload;
          state.riskTolerance.message = action.payload;
        } else {
          state.riskTolerance.message = "An unexpected error occurred";
        }
      })
      .addCase(getPreferredProducts.pending, (state) => {
        state.preferredProducts.status = "loading";
        state.preferredProducts.isLoading = true;
      })
      .addCase(getPreferredProducts.fulfilled, (state, action) => {
        state.preferredProducts.status = "idle";
        state.preferredProducts.data = action.payload;
        state.preferredProducts.isLoading = false;
      })
      .addCase(getPreferredProducts.rejected, (state, action) => {
        state.preferredProducts.status = "failed";
        state.preferredProducts.isLoading = false;
        if (action.payload) {
          state.preferredProducts.error = action.payload;
          state.preferredProducts.message = action.payload;
        } else {
          state.preferredProducts.message = "An unexpected error occurred";
        }
      })
      .addCase(getPoliticallyExposedPersonPositions.pending, (state) => {
        state.politicallyExposedPersonPositions.status = "loading";
        state.politicallyExposedPersonPositions.isLoading = true;
      })
      .addCase(
        getPoliticallyExposedPersonPositions.fulfilled,
        (state, action) => {
          state.politicallyExposedPersonPositions.status = "idle";
          state.politicallyExposedPersonPositions.data = action.payload;
          state.politicallyExposedPersonPositions.isLoading = false;
        }
      )
      .addCase(
        getPoliticallyExposedPersonPositions.rejected,
        (state, action) => {
          state.politicallyExposedPersonPositions.status = "failed";
          state.politicallyExposedPersonPositions.isLoading = false;
          if (action.payload) {
            state.politicallyExposedPersonPositions.error = action.payload;
            state.politicallyExposedPersonPositions.message = action.payload;
          } else {
            state.politicallyExposedPersonPositions.message =
              "An unexpected error occurred";
          }
        }
      )
      .addCase(getBeneficiaryRelationship.pending, (state) => {
        state.beneficiaryRelationship.status = "loading";
        state.beneficiaryRelationship.isLoading = true;
      })
      .addCase(getBeneficiaryRelationship.fulfilled, (state, action) => {
        state.beneficiaryRelationship.status = "idle";
        state.beneficiaryRelationship.data = action.payload;
        state.beneficiaryRelationship.isLoading = false;
      })
      .addCase(getBeneficiaryRelationship.rejected, (state, action) => {
        state.beneficiaryRelationship.status = "failed";
        state.beneficiaryRelationship.isLoading = false;
        if (action.payload) {
          state.beneficiaryRelationship.error = action.payload;
          state.beneficiaryRelationship.message = action.payload;
        } else {
          state.beneficiaryRelationship.message =
            "An unexpected error occurred";
        }
      })
      .addCase(deleteLookupValue.pending, (state) => {
        state.lookupsList.status = "loading";
      })
      .addCase(deleteLookupValue.fulfilled, (state, action) => {
        state.lookupsList.status = "idle";
        state.lookupsList.data = action.payload;
        state.lookupsList.isLoading = false;
      })
      .addCase(deleteLookupValue.rejected, (state, action) => {
        state.lookupsList.status = "failed";
        state.lookupsList.isLoading = false;
        if (action.payload) {
          state.lookupsList.error = action.payload;
          state.lookupsList.message = action.payload;
        } else {
          state.lookupsList.message = "An unexpected error occurred";
        }
      });
  },
});

export default lookupReducer.reducer;
